import { gql } from '@utils/gpl-dedup';
import { phoneFragment } from '@graphql/contacts/fragments';

export const userFragment = gql`
  fragment user on User {
    first_name
    last_name
    email
    timezone
    lang
    phone {
      ...phone
    }
    created_at
    updated_at
    notes
    ltv_provider_id
    email_username
    is_temp_password
    roles {
      id
      name
    }
    notification_email
    notification_app
    company_id
    is_chat_blocked
    notification_phone {
      ...phone
    }

    company {
      id
      uid
      name
    }
  }
  ${phoneFragment}
`;
